var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19997 14.9337L2.1333 2.66699H13.8666L12.8 14.9337H3.19997Z",
    fill: "#97B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.533333 2.13379C0.238781 2.13379 0 2.37257 0 2.66712C0 2.96167 0.238781 3.20046 0.533333 3.20046H1.6C1.60002 3.21574 1.60069 3.23115 1.60204 3.24666L2.58399 14.5391C2.65588 15.3659 3.34804 16.0005 4.17797 16.0005H11.8221C12.652 16.0005 13.3442 15.3659 13.4161 14.5391L14.398 3.24666C14.3994 3.23115 14.4 3.21574 14.4001 3.20046H15.4667C15.7612 3.20046 16 2.96167 16 2.66712C16 2.37257 15.7612 2.13379 15.4667 2.13379H0.533333ZM13.3314 3.20046H2.66871L3.64664 14.4467C3.67061 14.7223 3.90133 14.9338 4.17797 14.9338H11.8221C12.0987 14.9338 12.3295 14.7223 12.3534 14.4467L13.3314 3.20046Z",
    fill: "#97B7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1333 5.86634C10.1333 5.57179 9.89455 5.33301 9.6 5.33301C9.30545 5.33301 9.06667 5.57179 9.06667 5.86634V12.2663C9.06667 12.5609 9.30545 12.7997 9.6 12.7997C9.89455 12.7997 10.1333 12.5609 10.1333 12.2663V5.86634ZM6.93337 5.86635C6.93337 5.5718 6.69458 5.33302 6.40003 5.33302C6.10548 5.33302 5.8667 5.5718 5.8667 5.86635V12.2664C5.8667 12.5609 6.10548 12.7997 6.40003 12.7997C6.69458 12.7997 6.93337 12.5609 6.93337 12.2664V5.86635Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33337 0.533333C5.33337 0.238781 5.57216 0 5.86671 0H10.1334C10.4279 0 10.6667 0.238781 10.6667 0.533333C10.6667 0.827885 10.4279 1.06667 10.1334 1.06667H5.86671C5.57216 1.06667 5.33337 0.827885 5.33337 0.533333Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.4e0b641625d1d1c4307a28e97cb25c81.svg";
export { ForwardRef as ReactComponent };